function factory({ window, document, thn }) {
    const engine = {};
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            var thnHost = window.location.host;
            if (thnHost.match(/hotelesemporio.com|hotelesemporio-mx.bookings.la/)) {
                resolve('es');
            }
            else {
                resolve('en');
            }
        });
    };
    return engine;
}

export { factory };
